import React, { Component } from "react";
import { connect } from "react-redux";
import { FiPlus, FiUsers } from "react-icons/fi";
import Layout from "components/Layout";
import StoreFoldersList from "components/Documents/StoreFoldersList";
import StoreFolderEdit from "components/Documents/StoreFolderEditModal";
import Loading from "components/Loading";
import Modal from "components/Modal";
import { showModal, hideModal } from "actions/modalActions";
import { storeFoldersActions } from "actions/storeFoldersActions";
import "../styles/components/Documents.scss";

class StoreFolders extends Component {
	constructor(props) {
		super(props);
		// console.log(props);

		this.closeModal = this.closeModal.bind(this);
		this.openNewFolderModal = this.openNewFolderModal.bind(this);
	}

	async componentDidMount() {
		await this.props.getStoreFolders({ sort: "+name" });
	}

	closeModal() {
		this.props.hideModal();
	}

	openNewFolderModal() {
		this.props.showModal(
			{
				open: true,
				title: "Nueva carpeta",
				style: { width: "400px" },
				content: <StoreFolderEdit handleClose={this.closeModal} />,
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	getContent = () => {
		// console.log(this.state);
		if (this.props.loading) {
			return <Loading />;
		}

		if (this.props.error) {
			return <div className="no-results">No se han podido cargar las carpetas</div>;
		}

		return <StoreFoldersList />;
	};

	render() {
		return (
			<>
				<Layout className="page-folders" context="documents">
					<div className="heading">
						<h1 className="title">Carpetas</h1>
						<button
							type="button"
							title="Crear carpeta"
							onClick={this.openNewFolderModal}
							className="btn btn-new"
						>
							<FiPlus />
						</button>
					</div>

					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.storeFoldersReducer,
		loading: reducers.storeFoldersReducer.loading,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getStoreFolders: (options) =>
		dispatch(storeFoldersActions.getStoreFolders(options)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StoreFolders);
